<template>
	<div>
		<b-dropdown-item v-if="!notifcations.length">
			{{ $t('no-notifications') }}
		</b-dropdown-item>
		<b-list-group v-else>
			<b-list-group-item
				v-for="notification in notifcations"
				:key="notification.id"
			>
				<a class="d-flex justify-content-between notification-item">
					<span class="text-nowrap mw-100 text-truncate">{{ notification.text }}</span>
					<span class="text-nowrap text-muted">{{ formatDate(notification.createdAt) }}</span>
				</a>
			</b-list-group-item>
		</b-list-group>
	</div>
</template>

<script>
export default {
	name: 'NotificationList',
	data() {
		return {
			notifcations: [
				{
					type: 'info',
					text: 'Dummy notification',
					createdAt: 1587394090,
				},
			],
		};
	},
	mounted() {
		// @TODO: establish notification stream
	},
	methods: {
		formatDate(seconds) {
			return this.$luxon(seconds, { input: { format: 'seconds' }, output: { format: 'relative' } });
		},
	},
};
</script>

<style scoped>
.notification-item {
	width: 16rem;
}
</style>
